import React from "react";
import { connect } from "react-redux";
import Dropdown from "./Dropdown";
import PropTypes, { object } from "prop-types";
import Authorization from "../../../utility/authorization";

/**
 * Class to retrive operators Dropdown
 */
class BranchListDD extends React.Component {
  componentDidMount() {
    if (this.props.businessId) {
      this.dispatchAPI();
    }
  }
  dispatchAPI = () => {
    return this.props.dispatch({
      types: [
        `GET_BRANCH_DD_PENDING`,
        `GET_BRANCH_DD_FULFILLED`,
        `GET_BRANCH_DD_REJECTED`,
      ],
      method: "GET",
      url:
        "v1/users/tmc/branches/list/" +
        this.props.businessId +
        "?[filter][where][active]=true&",
      // returnExistObject: "corporateDD",
    });
  };
  componentDidUpdate(props) {
    if (this.props.businessId !== props.businessId) {
      this.dispatchAPI();
    }
  }

  render() {
    const {
      name,
      onBlur,
      onChange,
      value,
      dataValidationName,
      branchListDD: { response },
      ...rest
    } = this.props || "";
    console.log(
      { response },
      response,
      response && Object.keys(response).count
    );

    return (
      <Dropdown
        options={
          response &&
          response.data &&
          response.data.length > 0 &&
          response.data.map((type) => ({
            label: type.firstName,
            value: type.id,
          }))
        }
        optionOnChange={onChange}
        value={value}
        name={name}
        className="b-control dd-btn"
        dataValidationName={dataValidationName}
        {...rest}
      />
    );
  }
}
BranchListDD.propTypes = {
  branchListDD: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
export default connect((state) => {
  return {
    branchListDD: state.branchListDD,
  };
})(BranchListDD);
